import { Table } from "reactstrap";

import "./style.scss";
import { DataHeads, Domain } from "../../../../utils/Constant";

const generateMonthLabels = (fiscalYear: string) => {
  const [startYear, endYear] = fiscalYear.split("-");
  const yearSuffixStart = startYear.slice(2);
  const yearSuffixEnd = endYear;

  return [
    `${4}/${yearSuffixStart}`,
    `${5}/${yearSuffixStart}`,
    `${6}/${yearSuffixStart}`,
    `${7}/${yearSuffixStart}`,
    `${8}/${yearSuffixStart}`,
    `${9}/${yearSuffixStart}`,
    `${10}/${yearSuffixStart}`,
    `${11}/${yearSuffixStart}`,
    `${12}/${yearSuffixStart}`,
    `${1}/${yearSuffixEnd}`,
    `${2}/${yearSuffixEnd}`,
    `${3}/${yearSuffixEnd}`,
  ];
};

const generateTableData = () => [
  {
    domain: "Service",
    dataHeads: [
      "Pre-Foundational Attrition %",
      "Total Nos",
      "Attrition Nos (Cumulative)",
      "Foundational Attrition %",
      "Total Nos",
      "Attrition Nos (Cumulative)",
      "Advanced Attrition %",
      "Total Nos",
      "Attrition Nos (Cumulative)",
      "Expert Attrition %",
      "Total Nos",
      "Attrition Nos (Cumulative)",
    ],

    referenceData: [
      "62%",
      "64",
      "61",
      "67%",
      "63",
      "65",
      "69%",
      "66",
      "64",
      "71%",
      "67",
      "68",
    ],
    monthsData: [
      [
        "63%",
        "105%",
        "31%",
        "65%",
        "115%",
        "32%",
        "69%",
        "125%",
        "34%",
        "71%",
        "135%",
        "35%",
      ],
      [
        "64",
        "110",
        "33",
        "66",
        "120",
        "34",
        "70",
        "130",
        "36",
        "72",
        "140",
        "37",
      ],
      [
        "65",
        "115",
        "34",
        "67",
        "125",
        "35",
        "71",
        "135",
        "37",
        "73",
        "145",
        "38",
      ],
      [
        "66%",
        "120%",
        "35%",
        "68%",
        "130%",
        "36%",
        "72%",
        "140%",
        "38%",
        "74%",
        "150%",
        "39%",
      ],
      [
        "67",
        "125",
        "36",
        "69",
        "135",
        "37",
        "73",
        "145",
        "39",
        "75",
        "155",
        "40",
      ],
      [
        "68",
        "130",
        "37",
        "70",
        "140",
        "38",
        "74",
        "150",
        "40",
        "76",
        "160",
        "41",
      ],
      [
        "69%",
        "135%",
        "38%",
        "71%",
        "145%",
        "39%",
        "75%",
        "155%",
        "41%",
        "77%",
        "165%",
        "42%",
      ],
      [
        "70",
        "140",
        "39",
        "72",
        "150",
        "40",
        "76",
        "160",
        "42",
        "78",
        "170",
        "43",
      ],
      [
        "71",
        "145",
        "40",
        "73",
        "155",
        "41",
        "77",
        "165",
        "43",
        "79",
        "175",
        "44",
      ],
      [
        "72%",
        "150%",
        "41%",
        "74%",
        "160%",
        "42%",
        "78%",
        "170%",
        "44%",
        "80%",
        "180%",
        "45%",
      ],
      [
        "73",
        "155",
        "42",
        "75",
        "165",
        "43",
        "79",
        "175",
        "45",
        "81",
        "185",
        "46",
      ],
      [
        "74",
        "160",
        "43",
        "76",
        "170",
        "44",
        "80",
        "180",
        "46",
        "82",
        "190",
        "47",
      ],
    ],
  },
];

const AttritionRateTable = ({ fiscalYear }: { fiscalYear: string }) => {
  const months = generateMonthLabels(fiscalYear);
  const tableData = generateTableData();
  const [, endYear] = fiscalYear.split("-");
  const yearSuffixEnd = endYear;

  return (
    <div className="table-container">
      <Table className="attrition-rate-table" bordered>
        <thead>
          <tr>
            <th className="sticky-column domain">{Domain}</th>
            <th className="sticky-column data-heads">{DataHeads}</th>
            <th className="wide-column">
              {`${fiscalYear} Data for reference (in %) (updated as of Mar ${yearSuffixEnd})`}
            </th>
            {months.map((month, index) => (
              <th key={index} className="month-header">{`As on (${month})`}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, rowIndex) => (
            <>
              {row.dataHeads.map((dataHead, dataIndex) => (
                <tr key={`${rowIndex}-${dataIndex}`}>
                  {dataIndex === 0 && (
                    <td
                      rowSpan={row.dataHeads.length}
                      className="sticky-column domain bold-black"
                    >
                      {row.domain}
                    </td>
                  )}
                  <td
                    className={`sticky-column data-heads ${["Pre-Foundational Attrition %", "Foundational Attrition %", "Advanced Attrition %", "Expert Attrition %"].includes(dataHead) ? "bold-black" : ""}`}
                  >
                    {dataHead}
                  </td>
                  <td>{row.referenceData[dataIndex] || ""}</td>
                  {row.monthsData[dataIndex]?.map((data, monthIndex) => (
                    <td key={monthIndex}>{data}</td>
                  ))}
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AttritionRateTable;
